export default "__VITE_ASSET__ByYYNk9z__"